import React from "react";
import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { translate } from "./Language/Translate";

const FooterNavLinks = () => {
  return (
    <>
      <Nav.Link as={NavLink} exact to={`/datenschutz`} style={{color:"black"}}>
        {translate("Datenschutz")}
      </Nav.Link>
      <Nav.Link as={NavLink} exact to={`/impressum`} style={{color:"black"}}>
        {translate("Impressum")}
      </Nav.Link>
    </>
  );
};

export default FooterNavLinks;
